import { AddCircle, RemoveCircle, Sync } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Autocomplete,
  Button,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useState } from 'react';
import { toast } from 'react-toastify';

const timeOptions = [
  '12 AM',
  '01 AM',
  '02 AM',
  '03 AM',
  '04 AM',
  '05 AM',
  '06 AM',
  '07 AM',
  '08 AM',
  '09 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '01 PM',
  '02 PM',
  '03 PM',
  '04 PM',
  '05 PM',
  '06 PM',
  '07 PM',
  '08 PM',
  '09 PM',
  '10 PM',
  '11 PM'
];
const timeZones = Intl.supportedValuesOf('timeZone').map((timezone) => ({
  label: timezone,
  value: timezone
}));
const PublicationRow = ({ publicationTime, index, updatePublicationTime }) => {
  return (
    <TableRow key={index}>
      <TableCell>
        <Select
          size="small"
          value={publicationTime.weekday}
          onChange={(event) => {
            updatePublicationTime(index, { ...publicationTime, weekday: event.target.value });
          }}
          sx={{ border: 'none', '& fieldset': { border: 'none' } }}
        >
          <MenuItem value="Sunday">Sunday</MenuItem>
          <MenuItem value="Monday">Monday</MenuItem>
          <MenuItem value="Tuesday">Tuesday</MenuItem>
          <MenuItem value="Wednesday">Wednesday</MenuItem>
          <MenuItem value="Thursday">Thursday</MenuItem>
          <MenuItem value="Friday">Friday</MenuItem>
          <MenuItem value="Saturday">Saturday</MenuItem>
        </Select>
      </TableCell>
      <TableCell>
        <Select
          size="small"
          value={publicationTime.time}
          onChange={(event) => {
            updatePublicationTime(index, { ...publicationTime, time: event.target.value });
          }}
          sx={{ border: 'none', '& fieldset': { border: 'none' } }}
        >
          {timeOptions.map((time) => (
            <MenuItem value={time}>{time}</MenuItem>
          ))}
        </Select>
      </TableCell>
      <TableCell>
        <Stack
          display="flex"
          alignItems="center"
          width="100%"
          flexDirection="row"
          justifyContent="center"
        >
          <Autocomplete
            options={timeZones}
            sx={{ width: '500px' }}
            value={publicationTime.timezone}
            onChange={(event, newValue) => {
              updatePublicationTime(index, { ...publicationTime, timezone: newValue?.value });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                style={{
                  width: '180px'
                }}
                sx={{ border: 'none', '& fieldset': { border: 'none' } }}
              />
            )}
          />
          <IconButton
            onClick={() => {
              updatePublicationTime(index, null);
            }}
          >
            <RemoveCircle />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export const SyncTime = async (site, siteKey) => {
  if (site[siteKey].publication_time.length === 0) {
    return false;
  }

  if (site[siteKey].enabled === false) {
    return false;
  }

  try {
    const fn = httpsCallable(
      getFunctions(),
      siteKey === 'pinterest_settings' ? 'pinterestRequest' : 'instagramRequest'
    );
    await fn({
      siteId: site.id,
      publication_time: site[siteKey].publication_time,
      command: 'syncTime'
    });
    return true;
  } catch (e) {
    return false;
  }
};

const PublicationTimeChooser = ({ site, updateSite, siteKey }) => {
  return (
    <div
      style={{
        minWidth: '600px'
      }}
    >
      <Table size="small">
        <TableHead>
          <TableCell>Weekday</TableCell>
          <TableCell>Time</TableCell>
          <TableCell>TimeZone</TableCell>
        </TableHead>
        <TableBody>
          {site[siteKey].publication_time?.map((publicationTime, index) => (
            <PublicationRow
              publicationTime={publicationTime}
              index={index}
              updatePublicationTime={(index, newPublicationTime) => {
                const newPublicationTimes = site[siteKey].publication_time || [];
                if (newPublicationTime) {
                  newPublicationTimes[index] = newPublicationTime;
                } else {
                  if (newPublicationTimes.length > 1) newPublicationTimes.splice(index, 1);
                  else toast.error('At least one publication time is required');
                }
                updateSite({ [siteKey]: { publication_time: newPublicationTimes } });
              }}
            />
          ))}
        </TableBody>
      </Table>

      <Stack gap={2} width="100%" flexDirection="row" justifyContent="right" marginTop={2}>
        {/* <LoadingButton
          startIcon={<Sync />}
          variant="contained"
          color="primary"
          loading={isSyncing}
          onClick={SyncTime}
        >
          Sync time
        </LoadingButton> */}
        {site[siteKey].publication_time?.length < 7 && (
          <Button
            startIcon={<AddCircle />}
            variant="contained"
            color="primary"
            onClick={() => {
              const newPublicationTime = site[siteKey].publication_time || [];
              newPublicationTime.push({
                weekday: 'Saturday',
                time: '09 PM',
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
              });
              updateSite({ [siteKey]: { publication_time: newPublicationTime } });
            }}
          >
            Add
          </Button>
        )}
      </Stack>
    </div>
  );
};

export default PublicationTimeChooser;
